import { toast } from "react-toastify";
import fetchApi from "./fetchApi";

export async function handleFetch({
  url,
  method = "GET",
  body = {},
  isFormData = false,
  headers,
  onSuccess,
  onValidationError,
}) {
  try {
    const response = await fetchApi[method.toLowerCase()](
      url,
      body,
      isFormData,
      headers,
    );

    const { status, message, data, errorCode, detail } = response;

    if (status === "success") {
      onSuccess?.(data, message);
      return true;
    }

    if (status === "error") {
      if (errorCode === 422) {
        onValidationError?.(detail);
      } else {
        toast.error(message || "Something went wrong");
      }
      return false;
    }

    toast.error("Unexpected response");
    return false;
  } catch (error) {
    console.error("error", error);
    toast.error(error.message || "Request failed");
    return false;
  }
}
